import urlRegex from 'url-regex';

export function validateUrl(url) {
  const parsed = urlRegex({strict: false, exact: true}).test(url);
  return parsed;
}
